// data/blogData.jsx

import aiEngineerCert from "../assets/docs/AEDS0013284167880 - certification.pdf";
import claudeCode101Cert from "../assets/docs/certificate - claudecode101.pdf";
import awsAiPractitionerCert from "../assets/docs/AWS Certified AI Practitioner certificate.pdf";

export const blogData = [
  {
    id: "cert-3",
    tag: "Certification",
    title: "AWS Certified AI Practitioner",
    excerpt:
      "Certified by Amazon Web Services for foundational knowledge of AI, machine learning, and generative AI concepts, including foundation models, prompt engineering, responsible AI, and AWS AI/ML services such as Amazon Bedrock and SageMaker.",
    date: "September 26, 2026",
    link: awsAiPractitionerCert,
    publication: "Amazon Web Services",
  },
  {
    id: "cert-2",
    tag: "Certification",
    title: "Claude Code 101",
    excerpt:
      "Certified by Anthropic for completing Claude Code 101 covering agentic coding workflows and effective use of Claude Code as an AI pair programmer for real-world software engineering tasks.",
    date: "July 15, 2026",
    link: claudeCode101Cert,
    publication: "Anthropic",
  },
  {
    id: "cert-1",
    tag: "Certification",
    title: "AI Engineer for Data Scientists Associate",
    excerpt:
      "Certified by DataCamp for skills in building and deploying AI-powered applications covering large language models, prompt engineering, and integrating AI into data science workflows.",
    date: "June 7, 2026",
    link: aiEngineerCert,
    publication: "DataCamp",
  },
  {
    id: "blog-2",
    tag: "Publication",
    title: "Research Paper: Realistic Rendering System using GAN",
    excerpt:
      "Developed a generative adversarial network (GAN)-based rendering framework for automatic colorization of grayscale images and legacy video frames, producing perceptually realistic results.",
    date: "December 10, 2021",
    link: "https://www.researchgate.net/publication/356811882_REALISTIC_RENDERING_SYSTEM_USING_GAN",
    publication: "ResearchGate",
  },
];
